export const PageSizeExperiment = Object.freeze({
  'long': 'long',
  'short': 'short',
})
